// ─── Per-service nav definitions ───────────────────────────────────────
// Adding a service is two things — an entry in SERVICES (services.ts) and a
// NAV_<X> here.
// Backup, Auth and Tailscale keep their plain icons — the glyphs are
// Opengater's (see Sidebar).
const NAV_BACKUP = [
    { to: '/dashboard', icon: 'dashboard', label: 'Dashboard', end: true },
    { to: '/databases', icon: 'database', label: 'Databases' },
    { to: '/backups', icon: 'backups', label: 'Backups' },
    { to: '/jobs', icon: 'jobs', label: 'Jobs', badge: 'jobs' },
    { to: '/audit', icon: 'audit', label: 'Logs' },
];
const NAV_AUTH = [
    { to: '/auth', icon: 'dashboard', label: 'Dashboard', end: true },
    { to: '/auth/users', icon: 'users', label: 'Users' },
    { to: '/auth/services', icon: 'shield', label: 'Services' },
    // Users / Referrals / Sessions / Settings get added here as their
    // pages come online. Kept minimal until then — empty placeholders in
    // the sidebar make the panel feel half-built.
];
const NAV_TAILSCALE = [
    { to: '/tailscale', icon: 'dashboard', label: 'Dashboard', end: true },
    { to: '/tailscale/nodes', icon: 'database', label: 'Nodes' },
    { to: '/tailscale/users', icon: 'users', label: 'Users' },
    { to: '/tailscale/preauth', icon: 'key', label: 'Preauth keys' },
    { to: '/tailscale/routes', icon: 'tailscale', label: 'Routes' },
    { to: '/tailscale/acl', icon: 'audit', label: 'ACL Policy' },
    { to: '/tailscale/apikeys', icon: 'lock', label: 'API keys' },
];
const NAV_OPENGATER = [
    {
        title: '',
        items: [{ to: '/opengater/dashboard', icon: 'dashboard', label: 'Дашборд', end: true }],
    },
    {
        title: 'Пользователи',
        items: [
            { to: '/opengater/users', icon: 'users', label: 'Пользователи' },
            {
                to: '/opengater/deletion-failures',
                icon: 'warn',
                label: 'Проблемные удаления',
                badge: 'deletion-failures',
            },
            { to: '/opengater/user-triggers', icon: 'message', label: 'Триггеры' },
        ],
    },
    {
        title: 'Тарифы и оплата',
        items: [
            { to: '/opengater/pricing', icon: 'tag', label: 'Тарифы' },
            { to: '/opengater/landing-tariff-cards', icon: 'crown', label: 'Карточки лендинга' },
            { to: '/opengater/bonuses', icon: 'gift', label: 'Бонусы' },
            { to: '/opengater/devices', icon: 'device', label: 'Устройства' },
            { to: '/opengater/device-options', icon: 'devices', label: 'Опции устройств' },
            { to: '/opengater/currencies', icon: 'coins', label: 'Валюты' },
            { to: '/opengater/topup', icon: 'wallet', label: 'Пополнение' },
            { to: '/opengater/payment-periods', icon: 'cal', label: 'Периоды оплаты' },
        ],
    },
    {
        title: 'Платежи',
        items: [
            { to: '/opengater/orders', icon: 'receipt', label: 'Заказы' },
            { to: '/opengater/payment-reviews', icon: 'audit', label: 'Разбор покупок' },
            { to: '/opengater/payment-systems', icon: 'card', label: 'Платёжные системы' },
        ],
    },
    {
        title: 'Подписки',
        items: [
            { to: '/opengater/mirrors', icon: 'copy', label: 'Зеркала' },
            { to: '/opengater/subscription-domain', icon: 'globe', label: 'Домен подписки' },
            { to: '/opengater/subscription-job', icon: 'clock', label: 'Время списания' },
            { to: '/opengater/cutoff', icon: 'moon', label: 'Конец оплаченного дня' },
            { to: '/opengater/scheduler', icon: 'refresh', label: 'Расписание' },
        ],
    },
    {
        title: 'Локации',
        items: [
            { to: '/opengater/locations', icon: 'sliders', label: 'Локации' },
            { to: '/opengater/location-operations', icon: 'server', label: 'Операции' },
            { to: '/opengater/cache', icon: 'cloud', label: 'Кэш' },
        ],
    },
    {
        title: 'Маркетинг',
        items: [
            { to: '/opengater/referrals', icon: 'link', label: 'Реф. ссылки' },
            { to: '/opengater/events', icon: 'flag', label: 'Кампании' },
            { to: '/opengater/event-settings', icon: 'settings', label: 'Настройки кампаний' },
            { to: '/opengater/mailings', icon: 'broadcast', label: 'Рассылки' },
            { to: '/opengater/gifts', icon: 'ticket', label: 'Подарки' },
        ],
    },
    {
        title: 'Контент',
        items: [
            { to: '/opengater/news', icon: 'newspaper', label: 'Новости' },
            { to: '/opengater/bot-screen-images', icon: 'image', label: 'Изображения бота' },
            { to: '/opengater/legal-links', icon: 'shield', label: 'Юридические документы' },
        ],
    },
    {
        title: 'Система',
        items: [
            { to: '/opengater/registration-settings', icon: 'bolt', label: 'Темп регистраций' },
            { to: '/opengater/identity', icon: 'id', label: 'Идентификация' },
            { to: '/opengater/flow-ttl', icon: 'hourglass', label: 'TTL потоков' },
        ],
    },
];
function roleAllowsItem(serviceId, path, role) {
    if (role === 'admin')
        return true;
    if (serviceId === 'auth')
        return role === 'support' && path === '/auth/users';
    if (serviceId !== 'opengater')
        return false;
    if (role === 'support') {
        return (path === '/opengater/users' || path === '/opengater/orders' || path === '/opengater/events');
    }
    if (role === 'editor')
        return path === '/opengater/news';
    if (role === 'ad_manager' || role === 'ad_lead')
        return path === '/opengater/events';
    return false;
}
export function navGroupsForService(serviceId, role) {
    const source = serviceId === 'opengater'
        ? NAV_OPENGATER
        : [
            {
                title: '',
                items: serviceId === 'auth'
                    ? NAV_AUTH
                    : serviceId === 'tailscale'
                        ? NAV_TAILSCALE
                        : NAV_BACKUP,
            },
        ];
    if (role === undefined)
        return source;
    return source
        .map((group) => ({
        ...group,
        items: group.items.filter((item) => roleAllowsItem(serviceId, item.to, role)),
    }))
        .filter((group) => group.items.length > 0);
}
const ALL_GROUPS = ['backup', 'auth', 'tailscale', 'opengater'].flatMap((serviceId) => navGroupsForService(serviceId));
function matches(item, pathname) {
    return pathname === item.to || (!item.end && pathname.startsWith(item.to + '/'));
}
/** The section a path belongs to — the longest matching route. */
export function findNavEntry(pathname) {
    let best = null;
    for (const g of ALL_GROUPS) {
        for (const it of g.items) {
            if (matches(it, pathname) && (!best || it.to.length > best.to.length))
                best = it;
        }
    }
    return best;
}
const norm = (s) => s.toLowerCase().replace(/ё/g, 'е');
/** Sections whose name — or whose group's name — contains the query. */
export function filterNav(groups, query) {
    const q = norm(query.trim());
    if (!q)
        return groups;
    return groups
        .map((g) => ({
        ...g,
        items: g.items.filter((it) => norm(it.label).includes(q) || norm(g.title).includes(q)),
    }))
        .filter((g) => g.items.length > 0);
}
